import * as Yup from 'yup';
import { SarlaftOperationInternational } from '../../../../../../shared/types/modules/sarlaft';
export const initialValues: SarlaftOperationInternational = {
    foreignCurrencyTransactions: false,
    whichCurrencyTransactions: '',
    otherOperations: '',
    financialProductsAbroad: false,
    whichProductsAbroad: '',
    foreignCurrencyAccounts: false,
};

export const validationSchema = Yup.object({
    foreignCurrencyTransactions: Yup.boolean(),
    whichCurrencyTransactions: Yup.string().when(
        'foreignCurrencyTransactions',
        {
            is: true,
            then: () =>
                Yup.string().required(
                    'Este campo es obligatorio cuando hay transacciones en moneda extranjera'
                ),
        }
    ),
    otherOperations: Yup.string(),
    financialProductsAbroad: Yup.boolean(),
    whichProductsAbroad: Yup.string().when('financialProductsAbroad', {
        is: true,
        then: () =>
            Yup.string().required(
                'Este campo es obligatorio cuando hay productos financieros en el exterior'
            ),
    }),
    foreignCurrencyAccounts: Yup.boolean(),
});
